import React from 'react';
import { shallowEqual } from 'react-redux';
import { SimulationStates } from '../../globals';
import { PlaybackStopIcon, TriangleIconRight } from '../Iconset';
import { TooltipKeys } from "../tooltips/TooltipKeys";
import Button from '../layout/Button';
import { useTypedDispatch, useTypedSelector } from '../../state/hooks';
import {AppState} from "../../classes/AppState";
import useCurrentStep from '../reactUtils/useCurrentStep';
import Input from '../../classes/Input';
import { getKeybindingString } from '../../classes/utilities/InputUtils';
import { StoreActions } from '../../state/store';
import MenuBar from '../menus/MenuBar';
import Menu from '../menus/Menu';
import MenuItem from '../menus/MenuItem';
import { MenuAlignments } from '../../interfaces/enums';

export default function SimulationControls()
{
	const currentStep = useCurrentStep();
	const dispatch = useTypedDispatch();
	
	const simulationState = useTypedSelector(state => state.applicationModule.simulationState, shallowEqual);	

	if (!currentStep) return null;

	return (
		<div className="simulationControlsRoot"
			data-name={"simulation-controls-root"}
		>
			<Button className={"scenarioControlButton small"}
				data-name={`simulation-mode-control-${simulationState !== SimulationStates.Playing ? "start" : "stop" }`}
				data-mode={simulationState !== SimulationStates.Playing ? "start" : "stop"}
				onClick={() => 
				{ 
					if(simulationState !== SimulationStates.Playing)
					{
						dispatch(StoreActions.application.setSimulationAsViewer(false));
						AppState.startSimulation(true);
					}
					else
					{
						AppState.stopSimulation();
					}
				}}
				tooltip={simulationState !== SimulationStates.Playing ? TooltipKeys.SimulationStart : TooltipKeys.SimulationStop}
				iconRenderer={simulationState !== SimulationStates.Playing ? <TriangleIconRight scale={1.2} /> : <PlaybackStopIcon/>}
			/>
			<div className={"compoundMenuDrop"}>
				<MenuBar>
					<Menu align={MenuAlignments.Right}>
						<MenuItem content={"Simulate from current step"} 
							shortcut={getKeybindingString(Input.KeyBindings.ToggleSimulation)} 
							onClick={() => 
							{
								dispatch(StoreActions.application.setSimulationAsViewer(false));
								AppState.startSimulation(simulationState !== SimulationStates.Playing);
							}}
						/>
						<MenuItem content={"Simulate as Viewer"} 
							shortcut={getKeybindingString(Input.KeyBindings.SimulateAsViewer)} 
							onClick={() => 
							{
								AppState.startSimulation(simulationState !== SimulationStates.Playing);
								dispatch(StoreActions.application.setSimulationAsViewer(true));
							}}
						/>
					</Menu>
				</MenuBar>
			</div>
		</div>
	);
}